import React from 'react'
import { observer } from 'mobx-react'
import { useStore, useUiStore } from '../hooks/use-store'

export default function inject(name: 'store' | 'uistore') {
  return (Comp: any) => {
    return observer(React.forwardRef((props: any, ref) => {
      const ctx = { store: useStore(), uistore: useUiStore() }
      return <Comp ref={ref} {...{[name]: ctx[name]}} {...props} />
    }))
  }
}
